module.exports = __webpack_public_path__ + "static/macbook-cd9b30821221f1a13bf61ec81ee6848a.jpeg";